import { css } from '@linaria/core'
import { fragments } from '#styles/index'
import { themeColors } from '#styles/themes'

export const largeIconPageClass = css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: center;
  margin: auto;
  gap: 12px;
    
  > ._icon {
    width: 192px;
    height: 192px;
    background-color: ${themeColors.lineDefault};
    align-self: center;
  }

  > ._subtitle {
    align-self: center;
    ${fragments.textStyle.heading.xl.regular}
  }
  
  > ._message {
    align-self: center;
    ${fragments.textStyle.body.l.regular}
    text-align: center;
    margin-bottom: 32px;
    max-width: 600px;
    white-space: pre-line;
    
    > br {
      margin-bottom: 8px;
    }
  }

  > section {
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: flex-end;
  }
`
